<template>
	<header class="app-header newprimary">
		<v-layout row wrap align-center class="container">
			<v-flex xs9 pt-1>
				<v-layout row wrap align-center>
					<v-flex xs4>
						<img
							class="hidden-sm-and-down"
							src="/static/images-new/logos/logo-casamarket-white.svg"
							alt="logo casamarket, logo casa market"
							height="37"
						/>
						<img
							class="hidden-md-and-up"
							src="/static/images-new/logos/logo-casamarket-mini.svg"
							alt="logo casamarket, logo casa market"
							height="34"
						/>
					</v-flex>
					<v-flex xs8 class="column-middle column-visibility-md">
						<input-searcher
							color-white
							placeholder="¿Qué buscas?"
							v-model="searcher"
						></input-searcher>
					</v-flex>
				</v-layout>
			</v-flex>
			<v-flex xs3 class="column-visibility-md">
				<v-layout row wrap>
					<v-flex xs12 class="position-relative">
						<v-btn
							class="btn-auto btn-session ma-0"
							color="darkenprimary"
							depressed
						>
							Iniciar sesión
						</v-btn>
						<v-btn
							class="btn-auto btn-shop ma-0"
							color="primary"
							depressed
						>
							<img
								src="/static/images-new/icons/icon-shop.svg"
								alt="carrito de compras"
								height="22"
							/>
						</v-btn>
					</v-flex>
					<v-flex xs12 mt-1>
						<v-icon color="white" size="18">location_on</v-icon>
						<span
							v-if="locationData.address && locationData.alias"
							class="white--text caption w-semibold"
						>
							{{ locationData.address }} - {{ locationData.alias }}
						</span>
						<span
							v-else
							class="white--text caption w-semibold"
						>
							Seleccionar dirección
						</span>
						<v-btn
							class="ma-0"
							depressed
							flat
							icon
							@click="openLocationModal(true)"
						>
							<img
								src="/static/images-new/icons/icon-config-location.svg"
								alt="configurar ubicación"
								height="26"
							/>
						</v-btn>
					</v-flex>
				</v-layout>
			</v-flex>
		</v-layout>
	</header>
</template>

<script>
	import inputSearcher from '@/components/shared/input-searcher';

	function data() {
		return {
			searcher: '',
		};
	}

	export default {
		name: 'app-header',
		components: {
			inputSearcher,
		},
		data,
		props: {
			locationData: {
				default: () => {},
				type: Object,
			},
		},
	};
</script>

<style lang="scss" scoped>
	.app-header {
		height: 61px;
		position: fixed;
		width: 100%;
		z-index: 3;

		@media (min-width: 936px) {
			height: 82px;
		}

		.container {
			height: 61px;
			padding: 0px;

			@media (min-width: 936px) {
				height: auto;
			}
		}
	}

	.column-middle {
		padding-right: 5%;
	}

	.position-relative {
		position: relative;
	}

	.btn-session {
		border-bottom-left-radius: 16px;
		border-bottom-right-radius: 16px;
		height: 38px !important;
		min-width: 167px !important;
		z-index: 1;
	}

	.btn-shop {
		border-bottom-right-radius: 16px;
		height: 38px !important;
		left: 95px;
		min-width: 137px !important;
		padding-right: 6px;
		position: absolute;
		text-align: right;
	}

	.column-visibility-md {
		display: none;

		@media (min-width: 936px) {
			display: initial;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/market-place/app-header.vue